import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmApprovedModel = ({ show, handleClose, handleConfirm }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Approve</Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure you want to Approve?</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleConfirm}>
          Approved
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmApprovedModel;
